/* eslint-disable */
/**
 * 添加千位分隔符
 * @param num
 * @param addplus
 * @returns {string}
 */
function thousandsSeparator(num, addplus) {
  const plus = num > 0 && addplus ? '+' : '';
  return plus + num.toString().replace(/\d+/, (n) => // 先提取整数部分
    n.replace(/(\d)(?=(\d{3})+$)/g, ($1) => `${$1},`));
}

/**
 * 数据格式化
 * @param number
 * @param digits
 * @returns {string}
 */
function marketNumberFormat(number, digits = 2) {
  if (number === 0) {
    if (digits === 4) return '0.0000';
    return '0.00';
  }

  if (isNaN(parseInt(number)) || number === '') return number;

  const unit = /%/.test(number) ? '%' : '';
  number = parseFloat(number);
  let assignMentflag = false;
  if (number < 0) {
    number = -1 * number;
    assignMentflag = true;
  }
  digits = digits > 0 && digits <= 20 ? digits : 2;

  if (assignMentflag) number = `${(Math.ceil(Number(number) * Math.pow(10, digits) - 0.0001) / Math.pow(10, digits)).toFixed(digits)}`;
  else number = `${(Math.floor(Number(number) * Math.pow(10, digits) + 0.0001) / Math.pow(10, digits)).toFixed(digits)}`;

  const l = number.split('.')[0]
    .split('')
    .reverse();
  const r = number.split('.')[1];
  let t = '';
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '');
  }

  if (assignMentflag) return (`-${t.split('').reverse().join('')}.${r}${unit}`);
  return `${t.split('').reverse().join('')}.${r}${unit}`;
}

export {
  thousandsSeparator,
  marketNumberFormat,
};
